import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private authService: MsalService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.authService.instance.getAllAccounts().length > 0) {
      this.authService.logout();
    }
  }

  signIn(): void {
    this.router.navigate(['/home']);
  }

}
